import { forwardRef, type Ref, type SVGProps } from "react";
const IconFileMergeOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.41 3 26 8.59A3.73 3.73 0 0 1 27 11v17a2.006 2.006 0 0 1-2 2H7a2.006 2.006 0 0 1-2-2V4a2.006 2.006 0 0 1 2-2h11a3.73 3.73 0 0 1 2.41 1m4.18 7L19 4.41V10zM18 12h7v16H7V4h10v7c.002.552.448.998 1 1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M12.255 18.005a1.003 1.003 0 0 0 1-1 1.003 1.003 0 0 0-1-1h-1a1 1 0 1 0 0 2zm4.246 0a1.003 1.003 0 0 0 1-1 1.003 1.003 0 0 0-1-1h-1a1 1 0 1 0 0 2zm4.246 0a1.003 1.003 0 0 0 1-1 1.003 1.003 0 0 0-1-1h-1a1 1 0 1 0 0 2zm3.246 0h1v-2h-1a1 1 0 1 0 0 2m-15.984 0h-1v-2h1a1 1 0 1 1 0 2"
    />
  </svg>
);
const ForwardRef = forwardRef(IconFileMergeOutlineSVG);
ForwardRef.displayName = "IconFileMergeOutline";
export { ForwardRef as IconFileMergeOutline };
